import * as z from 'zod';

import { addressQuerySchema } from '@/_containers/inputs/address/shared/address-query-schema';
import { subsidiesTypeFormSchema, subsidiesTypeQuerySchema } from '@/_schemas/agreements/subsidies-type-schemas';

import { clientQuerySchemaSubsidiesLinker } from './linked-query-schemas';
import { subsidyItemsFormSchema, subsidyItemsQuerySchema } from './subsidy-items-schemas';

export const subsidyQuerySchema = z.object({
  id: z.number(),
  client: clientQuerySchemaSubsidiesLinker,
  client_id: z.number(),
  subsidy_type: subsidiesTypeQuerySchema,
  primary_contact: clientQuerySchemaSubsidiesLinker.shape.contacts,
  addresses: z.array(addressQuerySchema).nullable(),
  subsidy_deliverables: z.array(subsidyItemsQuerySchema),
});

export type SubsidyQuerySchema = z.infer<typeof subsidyQuerySchema>;

export const subsidyFormSchema = subsidyQuerySchema.omit({ client_id: true }).extend({
  client: clientQuerySchemaSubsidiesLinker.nullable().refine(
    (val) => {
      if (!val) {
        return false;
      }

      return val.id !== -1;
    },
    { message: 'Client is required' }
  ),
  subsidy_type: subsidiesTypeFormSchema.nullable().refine(
    (val) => {
      if (!val) {
        return false;
      }

      return true;
    },
    { message: 'Subsidy type is required' }
  ),
  primary_contact: clientQuerySchemaSubsidiesLinker.shape.contacts,
  addresses: z.array(addressQuerySchema).nullable(),
  subsidy_deliverables: z.array(subsidyItemsFormSchema),
});

export type SubsidyFormSchema = z.infer<typeof subsidyFormSchema>;

export const subsidyMutationSchema = subsidyFormSchema
  .omit({
    client: true,
  })
  .extend({
    agreement_id: z.number(),
    client_id: z.number(),
    primary_contact: z.array(z.number()).nullable(),
    addresses: z.array(z.number()).nullable(),
    subsidy_type: subsidiesTypeQuerySchema,
    subsidy_deliverables: z.array(z.number()).nullable(),
  });

export type SubsidyMutationSchema = z.infer<typeof subsidyMutationSchema>;
